class Filters
{
    constructor() {
        this.activeFilters = {};
        this.init();
    }

    init() {
        const toggleFiltersButton = document.querySelector('.toggle-filters');
        const filterModal = document.querySelector('.products-filter');
        const closeFiltersButton = document.querySelector('.products-filter .close');
        closeFiltersButton.addEventListener('click', (event) => {
            filterModal.classList.remove('active');
        });
        toggleFiltersButton.addEventListener('click', (event) => {
            event.preventDefault();
            filterModal.classList.toggle('active');
        });
        const filterElements = document.querySelectorAll('.filter');
        filterElements.forEach(filter => {
            filter.addEventListener('click', (event) => {
                event.preventDefault();
                // add active class to the clicked filter a element and remove it from others same category
                const filterCategory = event.target.parentElement.dataset.filter;
                const filterLinks = document.querySelectorAll(`.filter[data-filter="${filterCategory}"] a`);
                filterLinks.forEach(link => {
                    link.classList.remove('active');
                })
                event.target.classList.add('active');
                this.activeFilters[filterCategory] = event.target.dataset[filterCategory];
                this.applyFilters();
            });
        });
    }

    applyFilters() {
        const products = document.querySelectorAll('.serie');
        products.forEach(product => {
            let show = true;
            for (let [category, value] of Object.entries(this.activeFilters)) {
                if (product.dataset[category] !== value) {
                    show = false;
                    break;
                }
            }
            product.style.display = show ? '' : 'none';
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.toggle-filters')) {
        new Filters();
    }

});
